module.exports = "/_next/static/images/OgImage-8214d2e34f9cb02edd71e7af5df73d81.jpg";